module.exports = __webpack_public_path__ + "static/media/medium.83f64f22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/priority/medium.svg
// module id = 419
// module chunks = 0